export default __webpack_public_path__ + "static/media/ba.0d03ff7a.jpg";